import { render, staticRenderFns } from "./video-collect.vue?vue&type=template&id=729b28ab&scoped=true&"
import script from "./video-collect.vue?vue&type=script&lang=js&"
export * from "./video-collect.vue?vue&type=script&lang=js&"
import style0 from "./video-collect.vue?vue&type=style&index=0&id=729b28ab&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729b28ab",
  null
  
)

export default component.exports